export default __webpack_public_path__ + "static/media/eth-red-small.e738b96b.svg";